export const identify = userId => {
  if (window.heap) {
    window.heap.identify(userId, 'ID');
  }
};

export const track = (eventName, data) => {
  if (window.heap) {
    window.heap.track(eventName, data);
  }
};
